module.exports = __webpack_public_path__ + "img/Wassilli Cover.28401744.jpg";